/* eslint-disable max-len */

import getObjectAttributeFromStringKey from '@/common-utils/functions/getObjectAttributeFromStringKey';
import { client } from '../../../../../common-utils/libraries/axios/axios';
import { POS_TERMINALS } from '../apiUrls';
import { buildUrl, replaceParameters } from '@/common-utils/functions/restUtils';
import generateNestedFieldAccessor from '@/common-utils/functions/generateNestedFieldAccessor';
import transactionsFields from '../../../remoteCollections/fields/transactionsFields';


/**
 *
 * @param root0
 * @param root0.items
 * @param root0.totalResults
 * @returns {Object}
 */
function mapResponseData({ items, totalResults }) {
    const data = {};

    const mappedItems = items.map(item => ({

        [transactionsFields.APPLICATION.key]: item[transactionsFields.APPLICATION.key],
        [transactionsFields.ORIGIN_APPLICATION.key]: item[transactionsFields.ORIGIN_APPLICATION.key],
        [transactionsFields.UUID.key]: item[transactionsFields.UUID.key],
        [transactionsFields.LOCAL_TRANSACTION_DATE_TIME.key]: item[transactionsFields.LOCAL_TRANSACTION_DATE_TIME.key],
        [transactionsFields.EVENT_TYPE.key]: item[transactionsFields.EVENT_TYPE.key],
        [transactionsFields.APPLICATION.key]: item[transactionsFields.APPLICATION.key],
        [transactionsFields.CONTRACT.key]: item[transactionsFields.CONTRACT.key],
        [transactionsFields.POS_TERMINAL.key]: {
            [transactionsFields.POS_TERMINAL.LABEL.key]: getObjectAttributeFromStringKey(item, generateNestedFieldAccessor(transactionsFields.POS_TERMINAL.LABEL))
        },
        [transactionsFields.RANK.key]: item[transactionsFields.RANK.key],
        [transactionsFields.BANK_CODE.key]: item[transactionsFields.BANK_CODE.key],
        [transactionsFields.AMOUNT.key]: item[transactionsFields.AMOUNT.key],
        [transactionsFields.TYPE.key]: item[transactionsFields.TYPE.key],
        [transactionsFields.AUTHORIZATION_CODE_RESULT.key]: item[transactionsFields.AUTHORIZATION_CODE_RESULT.key],
        [transactionsFields.AUTHORIZATION_CODE.key]: item[transactionsFields.AUTHORIZATION_CODE.key],
        [transactionsFields.PAN.key]: item[transactionsFields.PAN.key],
        [transactionsFields.EXPIRATION_DATE.key]: item[transactionsFields.EXPIRATION_DATE.key],
        [transactionsFields.AUTHORIZATION_NUMBER.key]: item[transactionsFields.AUTHORIZATION_NUMBER.key],
        [transactionsFields.CARD_DETAILS.key]:
        {
            [transactionsFields.CARD_DETAILS.PRODUCT.key]: item[transactionsFields.CARD_DETAILS.key] && getObjectAttributeFromStringKey(item, generateNestedFieldAccessor(transactionsFields.CARD_DETAILS.PRODUCT)),
            [transactionsFields.CARD_DETAILS.TYPE.key]: item[transactionsFields.CARD_DETAILS.key] && getObjectAttributeFromStringKey(item, generateNestedFieldAccessor(transactionsFields.CARD_DETAILS.TYPE))
        },
        [transactionsFields.RECONCILIATION_NUMBER.key]: item[transactionsFields.RECONCILIATION_NUMBER.key],
        [transactionsFields.POS_REMITTANCE_NUMBER.key]: item[transactionsFields.POS_REMITTANCE_NUMBER.key],
        [transactionsFields.FILE_NUMBER.key]: item[transactionsFields.FILE_NUMBER.key],
        [transactionsFields.LEGAL_NAME.key]: item[transactionsFields.LEGAL_NAME.key],
        [transactionsFields.REGISTRATION_NUMBER.key]: item[transactionsFields.REGISTRATION_NUMBER.key]

    }));

    data.items = mappedItems;
    data.totalResults = totalResults;
    return data;
}

const queryTransactions = ({ query, posTerminalId }, enabled) => {
    return {
        queryKey: [POS_TERMINALS.TRANSACTIONS.queryKey, posTerminalId, query],
        queryFn: async () => {
            const response = await client.get(buildUrl(replaceParameters(POS_TERMINALS.TRANSACTIONS.url, { posTerminalId: posTerminalId }), query));
            return mapResponseData(response.data);
        },
        enabled: enabled
    };
};


export default queryTransactions;